module.exports = __webpack_public_path__ + "img/bottom1.c87da673.jpg";